export default __webpack_public_path__ + "static/media/compactor.7797a9e2.jpg";